import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from '../CustomButton/CustomButton'
import ComboBox from '../ComboBox'
import { Input } from '../Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest } from '../../utils/api'
import urls from '../../utils/urls'
import { currentDate } from '../../utils/helpers'

export default function CreateDocumentsForm({ setNewRows, account, params }) {
  const [open, setOpen] = useState(false)
  const [types, setTypes] = useState([])
  const [file, setFile] = useState(null)

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Type: '',
      Nom: '',
      Description: '',
      Externe: '',
      Datedéchéance: currentDate(),
    },
  })

  const fetchDocumentsTypes = async () => {
    const url = urls.fetchDocumentsTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Type}`, id: v.id, cat: v.categorie, domain: v.Domains })
      })
      // setTypes([...filterTypes])
      if (account === 'Comptes') {
        setTypes(filterTypes)
      } else if (account === 'Immobilier') {
        setTypes(filterTypes.filter((e) => e.cat === 'Logement'))
      } else if (account === 'Véhicules') {
        setTypes(filterTypes.filter((e) => e.cat === 'Transport'))
      } else if (account === 'PlanMaintenance') {
        setTypes(filterTypes.filter((e) => e.cat === 'Entretien'))
      } else if (account === 'ParcoursPro') {
        setTypes(filterTypes.filter((e) => e.domain === 'Professionnel'))
      } else {
        setTypes(filterTypes)
      }
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
    fetchDocumentsTypes()
  }

  const handleClose = () => {
    setOpen(false)
    setFile(null)
  }

  const onSubmit = async (data) => {
    const formData = new FormData()
    if (file != null) formData.append('Lien', file)
    formData.append('Type', data.Type.id)
    if (account === 'Comptes') formData.append('Affectation', params.id)
    if (account === 'Immobilier') formData.append('Immobilier', params.id)
    if (account === 'Véhicules') formData.append('Vehicledata', params.id)
    if (account === 'PlanMaintenance') formData.append('PlanMaintenance', params.id)
    if (account === 'ParcoursPro') formData.append('ParcoursPro', params.id)
    if (account === 'OperationFi') formData.append('operationsfi', params.id)

    formData.append('Nom', data.Nom)
    formData.append('Description', data.Description)
    formData.append('Externe', data.Externe)
    formData.append('Datedéchéance', data.Datedéchéance)

    const response = await makePostRequest(
      urls.crudDocumentsDetailsOperations,

      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (response.status === 201) {
      let result = response.data

      setNewRows((newRows) => {
        return [...newRows, result]
      })

      handleClose()
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>Add Document</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'Black !important' }}>Ajouter Document</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Type', j)}
              label="Type de document "
              data={types}
              name="Type"
              required={true}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Nom"
              label="Nom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Description"
              label="Description"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Externe"
              label="N° Externe"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Datedéchéance"
              label="Datedéchéance"
            />
            <Button
              variant="contained"
              component="label"
              sx={{
                color: 'black',
                background: 'none',
                '&:hover': {
                  backgroundColor: '#aeaeae',
                },
              }}
            >
              <input
                name="file"
                type="file"
                filename={file}
                required={true}
                // accept="application/pdf"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Button>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Mettre à jour</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
